<h3 *ngIf="!loading && mode === 'New'">Create Workflow Role</h3>
<h3 *ngIf="!loading && mode === 'Edit'">Modify Workflow Role</h3>
<h3 *ngIf="loading">Loading</h3>

<form *ngIf="workflowRoleForm" nz-form [formGroup]="workflowRoleForm" (ngSubmit)="doSubmit()">
	<nz-card nzTitle="Workflow Role Form" *ngIf="!loading" [nzExtra]="saveTmpl">
		<ng-template #saveTmpl>
			<button *ngIf="mode == 'New'" nz-button nzType="primary" [disabled]="workflowRoleForm.invalid">Create</button>
			<button *ngIf="mode == 'Edit'" nz-button nzType="primary" [disabled]="workflowRoleForm.invalid">Save</button>
		</ng-template>

		<!-- Workflow selection - only in New mode -->
		<nz-form-item *ngIf="mode === 'New' && workflows.length > 0">
			<nz-form-label [nzSpan]="6" nzRequired>Workflow</nz-form-label>
			<nz-form-control [nzSpan]="18">
				<nz-select formControlName="workflow" nzPlaceHolder="Select a workflow">
					<nz-option *ngFor="let workflow of workflows" [nzValue]="workflow" [nzLabel]="workflow.name">
					</nz-option>
				</nz-select>
			</nz-form-control>
		</nz-form-item>

		<!-- Workflow display - only in Edit mode -->
		<nz-form-item *ngIf="mode === 'Edit'">
			<nz-form-label [nzSpan]="6">Workflow</nz-form-label>
			<nz-form-control [nzSpan]="18">
				<input nz-input [value]="workflowRoleForm.get('workflow')!.value.label" readonly />
			</nz-form-control>
		</nz-form-item>

		<!-- Role Name -->
		<nz-form-item>
			<nz-form-label [nzSpan]="6" nzRequired>Role Name</nz-form-label>
			<nz-form-control [nzSpan]="18">
				<input nz-input formControlName="name" placeholder="Name" />
			</nz-form-control>
		</nz-form-item>

		<!-- Description -->
		<nz-form-item>
			<nz-form-label [nzSpan]="6">Description</nz-form-label>
			<nz-form-control [nzSpan]="18">
				<input nz-input formControlName="description" placeholder="Description" />
			</nz-form-control>
		</nz-form-item>

		<nz-form-item>
			<nz-form-label [nzSpan]="6" nzRequired>Active</nz-form-label>
			<nz-form-control [nzSpan]="18">
				<nz-select formControlName="active" nzPlaceHolder="Is Active">
					<nz-option [nzValue]="true" nzLabel="Active"></nz-option>
					<nz-option [nzValue]="false" nzLabel="Inactive"></nz-option>
				</nz-select>
			</nz-form-control>
		</nz-form-item>
	</nz-card>



	<nz-card nzTitle="Workflow States" *ngIf="mode == 'Edit'" class="mt-5">
		<h3>Roles and Permission</h3>

		<nz-table nzSize="small" [nzData]="[0]" [nzFrontPagination]="false">
			<thead>
				<tr>
					<th>Step</th>
					<th colSpan="2">Status</th>
					<!-- <th [nzChecked]="areAllSelected()" [nzIndeterminate]="areSomeSelected()" (nzCheckedChange)="setMultipleSelected($event)"></th> -->
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let status of getStatusFormGroups()">
					<td>{{status.get('workflowStep')!.value.label}}</td>
					<td>{{status.get('workflowStepStatus')!.value.label}}</td>
					<td class="text-center">
						<nz-radio-group [formControl]="getStatusTypeFormControl(status)" nzSize="small" nzButtonStyle="solid">
							<label nz-radio-button nzValue="ViewOnly">View Only</label>
							<label nz-radio-button nzValue="ListAndView">List & View</label>
							<label nz-radio-button nzValue="ListViewAndProcess">List, View & Process</label>
						</nz-radio-group>
					</td>
				</tr>
			</tbody>
		</nz-table>
	</nz-card>

	<nz-card nzTitle="Agent Linking" *ngIf="mode === 'Edit'" class="mt-5">
		<h3>Agents</h3>

		<nz-table
			#agentTable
			nzSize="small"
			[nzData]="workflowRole!.agents"
			[nzFrontPagination]="true"
			[nzPageSize]="30"
			[nzShowPagination]="true">
			<thead>
				<tr>
					<th>ID</th>
					<th>Agent Name</th>
					<th>Agent Surname</th>
					<th class="text-center">Link</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let agent of agentTable.data">
					<td>{{ agent.agentId }}</td>
					<td>{{ agent.agentName }}</td>
					<td>{{ agent.agentSurname }}</td>
					<td class="text-center">
						<label nz-checkbox [(ngModel)]="agent.linked" [ngModelOptions]="{standalone: true}" name="agent_link_{{agent.agentId}}"></label>
					</td>
				</tr>
			</tbody>
		</nz-table>
	</nz-card>

	<div class="text-right mt-3" *ngIf="mode == 'Edit'">
		<button nz-button nzType="primary" [disabled]="workflowRoleForm.invalid">
			Submit
		</button>
	</div>
</form>
